import { render } from "./GlTransactionIcon.vue?vue&type=template&id=4abf794d"
import script from "./GlTransactionIcon.vue?vue&type=script&lang=js"
export * from "./GlTransactionIcon.vue?vue&type=script&lang=js"
script.render = render

export default script